import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Contract for source panel API operations.
 * Implemented by ChatbotService (chatbot) and RegulationAgentSourceApiService (regulation agent).
 */
export interface ISourcePanelApi {
  searchMetadata(
    tenantId: string,
    searchTerm: string,
    chatHistoryId: string,
    relevance: string | null,
    sort_by: string
  ): Observable<any>;

  ViewInsightFile(fileName: string, tenantId: any, insight_id: any): Observable<any>;

  DownloadRtqFile(document_id: string): Observable<any>;

  GetDocChatUrl(fileName: any, insight_id: any): Observable<any>;
}

/** Injection token for optional source panel API (agent provides; chatbot uses ChatbotService). */
export const SOURCE_PANEL_API = new InjectionToken<ISourcePanelApi>('SOURCE_PANEL_API');
